import { Component, OnInit } from '@angular/core';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CountProductRequest, ProductResponse } from 'src/app/models/product.model';
import { ProductService } from 'src/app/services/product.service';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { DateUtil } from 'src/app/common/util';
import { DayExistenceCountResponse, ExistenceCountRequest, ExistenceCountResponse, InventoryCountTodayResponse } from 'src/app/models/inventory.model';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';

@Component({
  selector: 'app-count-inventory',
  templateUrl: './count-inventory.component.html',
  styleUrls: ['./count-inventory.component.scss']
})
export class CountInventoryComponent implements OnInit {
  warehouses: WarehouseResponse[] = [];
  allWarehouses: WarehouseResponse[] = [];
  filterWarehouse: InputAutocompleteModel = new InputAutocompleteModel("", false, true, "", "", "", "", null, []);
  allowedWarehouses: { [key: number]: boolean } = {};
  timeout = null;
  products: CountProductRequest[] = [];
  loadingProducts = false;
  addingDescription = null;
  view = 0;
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  user: number = null;
  missing: number = 0;
  counted = false;
  modalPriorities = false;
	permissionType = PermissionTypeEnum;
  savingIndividual: { [key: number]: boolean } = {};

  constructor(
    private warehouseService: WarehouseService,
    private authService: AuthenticationService,
    private toastService: ToastrService,
    private productService: ProductService,
    private inventoryService: InventoryService
  ) {
    var getUserPosition = authService.getUserPosition();
    if (getUserPosition) {
      getUserPosition.forEach((u) => {
        if (u.warehouse != 0) {
          this.allowedWarehouses[u.warehouse] = true;
        }
      });
    }
    this.user = JSON.parse(authService.getCurrentUser()).id;
  }

  ngOnInit(): void {
    this.getWarehousesByFilter();
    this.getMissingWarehousesToCount();
  }

  getMissingWarehousesToCount() {
    this.inventoryService.getMissingWarehousesToCount().subscribe({
      next: (response: ResponseObject) => {
        this.missing = response.data.length;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getProducts() {
    this.products = [];
    this.counted = false;
    this.loadingProducts = true;
    let actual = DateUtil.getActualDate();
    let counted = DateUtil.parseDateToMilliseconds(actual);
    this.inventoryService.getInventoryRandom(
      counted,
      this.user,
      this.filterWarehouse.data.id
    ).subscribe({
      next: (response: ResponseObject) => {
        var inventory = response.data as InventoryCountTodayResponse;
        var list = inventory.list;
        list.forEach((existence) => {
          var temp = new CountProductRequest();
          var tempProduct = new ProductResponse();
          tempProduct.name = existence.nameProduct;
          tempProduct.id = existence.idProduct;
          tempProduct.barCode = existence.barCode;
          tempProduct.code = existence.codeProduct;
          temp.product = tempProduct;
          temp.id = existence.id;
          temp.units = existence.physicalStock;
          temp.counted = existence.idUser != null;
          temp.comments = existence.comment;
          this.products.push(temp);
          if (tempProduct.image) {
            console.log(tempProduct.image);
          }
        });
        this.loadingProducts = false;
        // this.counted = inventory.counted;
      },
      error: (error: HttpErrorResponse) => {
        this.loadingProducts = false;
        console.log(error);
        this.toastService.error(error.error.message);
      }
    })
  }


  selectWarehouse(warehouse: WarehouseResponse) {
    this.filterWarehouse.value = warehouse.name;
    this.filterWarehouse.verified = true;
    this.filterWarehouse.data = warehouse;
    this.filterWarehouse.class = "fa-circle-check";
    this.getProducts();
  }

  searchWarehouse() {
    clearTimeout(this.timeout);
    this.filterWarehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.getWarehousesByFilter();
    }, 300);
  }

  getWarehousesByFilter() {
    this.filterWarehouse.class = "loading";
    this.warehouseService.getWarehouseByClue(this.filterWarehouse.value).subscribe({
      next: (response: ResponseObject) => {
        this.allWarehouses = response.data as WarehouseResponse[];
        this.warehouses = this.allWarehouses.filter((warehouse) => {
          return this.allowedWarehouses[warehouse.id]
        })
        if (this.warehouses.length == 0) {
          this.warehouses = this.allWarehouses;
        }
        this.selectWarehouse(this.warehouses[0]);
      },
      error: (error: HttpErrorResponse) => {
        this.filterWarehouse.class = "fa-xmark";
        this.toastService.error(error.error.message);
      }
    })
  }

  saveCount() {

    if (this.buttonSave.loading) {
      return;
    }

    this.buttonSave.loading = true;

    const request: ExistenceCountRequest[] = [];

    this.products.forEach((product) => {

      // Ya fue guardado individualmente entonces no se manda
      if (product.counted) {
        return;
      }

      const existence = new ExistenceCountRequest();

      existence.comment =
        product.comments ? product.comments : null;

      existence.id = product.id;
      existence.physicalStock = product.units;

      request.push(existence);
    });

    if (request.length === 0) {
      this.buttonSave.loading = false;
      this.toastService.info("Todos los productos ya fueron guardados");
      return;
    }

    this.inventoryService
      .setPhysicalStockOfList(request, this.user)
      .subscribe({
        next: (response: ResponseObject) => {

          this.buttonSave.loading = false;

          this.reset();

          this.toastService.success(response.data);
        },
        error: (error: HttpErrorResponse) => {

          this.buttonSave.loading = false;

          this.toastService.error(error.error.message);
        }
      });
  }

  reset() {
    this.getWarehousesByFilter();
    this.getMissingWarehousesToCount();
  }

  getDisabledSave() {

    let pendingProducts = 0;

    for (let i = 0; i < this.products.length; i++) {

      const product = this.products[i];

      if (product.counted) {
        continue;
      }

      pendingProducts++;

      if (
        (product.units === 0 && !product.confirmZero) ||
        product.units === undefined ||
        product.units === null
      ) {
        return true;
      }
    }

    return pendingProducts === 0;
  }
  
  saveCountIndividual(product: CountProductRequest) {

    if (!product || !product.id) {
      this.toastService.error("No se encontró el producto a guardar");
      return;
    }

    if (
      product.units === undefined ||
      product.units === null ||
      (product.units === 0 && !product.confirmZero)
    ) {
      this.toastService.warning("Ingresa las unidades o confirma las cero existencias");
      return;
    }

    if (this.savingIndividual[product.id]) {
      return;
    }

    this.savingIndividual[product.id] = true;

    const request = new ExistenceCountRequest();

    request.id = product.id;
    request.physicalStock = product.units;
    request.comment = product.comments ? product.comments : null;

    this.inventoryService
      .setPhysicalStockOfListIndividual(request, this.user)
      .subscribe({
        next: (response: ResponseObject) => {

          this.savingIndividual[product.id] = false;

          this.toastService.success(response.data);

          // Opcional:
          // marcar este producto como contado para deshabilitarlo
          (product as any).counted = true;
        },
        error: (error: HttpErrorResponse) => {

          this.savingIndividual[product.id] = false;

          this.toastService.error(
            error.error?.message || "No se pudo guardar el conteo"
          );
        }
      });
  }

}
